/**
 * PlusSign Component
 *
 * The + symbol that sits between the logo halves (80×80px).
 * Cream (bottom-right) half uses a PailletteFace canvas.
 * Charcoal (top-left) half uses a second PailletteFace with muted glints.
 */

import React from 'react';
import PailletteFace from '../components/PailletteFace';

interface PlusSignProps {
  style?: React.CSSProperties;
}

const CREAM_PATH = 'M34.188 79.225c-.468-.517-.7-1.396-.7-2.636V48.372c0-.604-.175-1.048-.527-1.33l-.013.011 14.105-14.106c.26.257.699.385 1.319.385h28.217c1.24 0 2.119.233 2.636.7.518.464.775 1.368.775 2.712v6.512c0 1.344-.257 2.248-.775 2.713s-1.396.696-2.636.696H48.372c-.62 0-1.059.131-1.319.388-.257.26-.385.699-.385 1.319v28.217c0 1.24-.259 2.12-.776 2.636-.517.518-1.448.775-2.79.775h-6.203c-1.343 0-2.247-.257-2.711-.775Z';

const CHARCOAL_PATH = 'M31.628 46.665H3.411c-1.24 0-2.118-.23-2.635-.696C.259 45.504 0 44.6 0 43.256v-6.512c0-1.344.259-2.248.776-2.712.517-.467 1.395-.7 2.635-.7h28.217c1.24 0 1.86-.568 1.86-1.704V3.411c0-1.24.232-2.118.7-2.635C34.652.26 35.556 0 36.898 0h6.203c1.343 0 2.274.259 2.791.776.517.517.776 1.395.776 2.635v28.217c0 .62.128 1.059.385 1.319L32.948 47.053l.013-.012c-.308-.249-.753-.376-1.333-.376Z';

const CHARCOAL_MASK = `url("data:image/svg+xml,${encodeURIComponent(
  `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 80 80'><path fill='white' fill-rule='evenodd' d='${CHARCOAL_PATH}'/></svg>`
)}")`;

const PlusSign: React.FC<PlusSignProps> = ({ style }) => (
  <div
    style={{
      position: 'absolute',
      left: '445px',
      top: '45px',
      width: '80px',
      height: '80px',
      ...style,
    }}
  >
    {/* Layer 0: Cream paillette — clipped to bottom-right half */}
    <div style={{
      position: 'absolute', inset: 0,
      clipPath: `path(evenodd,'${CREAM_PATH}')`,
    }}>
      <PailletteFace width={80} height={80} columnIndex={102} />
    </div>
    {/* Layer 1: Charcoal paillette — masked to top-left half */}
    <div style={{
      position: 'absolute', inset: 0,
      WebkitMaskImage: CHARCOAL_MASK,
      maskImage: CHARCOAL_MASK,
      WebkitMaskSize: '100% 100%',
      maskSize: '100% 100%' as string,
      WebkitMaskRepeat: 'no-repeat',
      maskRepeat: 'no-repeat' as string,
    }}>
      <PailletteFace width={80} height={80} columnIndex={105} baseColor="#262626" glintIntensity={0.25} />
    </div>
  </div>
);

export default PlusSign;
